import { render, staticRenderFns } from "./resume-info.vue?vue&type=template&id=582603f4&"
import script from "./resume-info.vue?vue&type=script&lang=js&"
export * from "./resume-info.vue?vue&type=script&lang=js&"
import style0 from "./resume-info.vue?vue&type=style&index=0&id=582603f4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports